import { useEffect, useState } from 'react';

import { VehicleOfficeSearchViewModel } from '@api/index';
import { CAR_RENTAL_PAST_SEARCH } from '@constants/constants';

export interface IPastSearchVehicleItem {
  dep: VehicleOfficeSearchViewModel;
  arr: VehicleOfficeSearchViewModel;
}
export const useVehiclePastSearches = () => {
  const [pastVehicleItems, setPastVehicleItems] =
    useState<Array<VehicleOfficeSearchViewModel>>();

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const storedData = localStorage.getItem(CAR_RENTAL_PAST_SEARCH);
    let pastItems: VehicleOfficeSearchViewModel[] = [];

    if (storedData) {
      try {
        const parsedData = JSON.parse(storedData);

        // Migration logic: Check if the stored data uses old model (with 'code' field)
        // If any item has 'code' field but no 'slug' field, clear the old data
        const hasOldModel = parsedData.some(
          (item: unknown) =>
            item &&
            typeof item === 'object' &&
            'code' in item &&
            !('slug' in item)
        );

        if (hasOldModel) {
          // Clear old data and start fresh
          localStorage.removeItem(CAR_RENTAL_PAST_SEARCH);
          pastItems = [];
        } else {
          // Data is in new format, keep it
          pastItems = parsedData;
        }
      } catch (error) {
        // If parsing fails, clear the corrupted data
        localStorage.removeItem(CAR_RENTAL_PAST_SEARCH);
        pastItems = [];
      }
    }

    // Ensure localStorage has the current data
    localStorage.setItem(CAR_RENTAL_PAST_SEARCH, JSON.stringify(pastItems));
    setPastVehicleItems(pastItems);
  }, []);

  const saveVehicleSearch = ({ dep, arr }: IPastSearchVehicleItem) => {
    let vehicleItems: VehicleOfficeSearchViewModel[] = [];

    vehicleItems = pastVehicleItems ? [...pastVehicleItems] : [];

    const newDestinations = [arr, dep];

    if (!vehicleItems.find((i) => i.slug === newDestinations[0]?.slug)) {
      vehicleItems.unshift(newDestinations[0]);
    } else {
      const target = vehicleItems.find(
        (i) => i.slug === newDestinations[0].slug
      );

      const targetIndex = target ? vehicleItems.indexOf(target) : -1;

      vehicleItems.splice(targetIndex, 1);
      vehicleItems.unshift(newDestinations[0]);
    }

    //deperture

    if (!vehicleItems.find((i) => i.slug === newDestinations[1].slug)) {
      vehicleItems.unshift(newDestinations[1]);
    } else {
      const target = vehicleItems.find(
        (i) => i.slug === newDestinations[1].slug
      );

      const targetIndex = target ? vehicleItems.indexOf(target) : -1;

      vehicleItems.splice(targetIndex, 1);
      vehicleItems.unshift(newDestinations[1]);
    }

    if (typeof window !== 'undefined') {
      localStorage.setItem(
        CAR_RENTAL_PAST_SEARCH,
        JSON.stringify(vehicleItems)
      );
      setPastVehicleItems(vehicleItems);
    }
  };

  const clearPastVehicleSearch = () => {
    if (typeof window !== 'undefined') {
      localStorage.removeItem(CAR_RENTAL_PAST_SEARCH);
      setPastVehicleItems([]);
    }
  };

  const removePastVehicleSearch = (item: VehicleOfficeSearchViewModel) => {
    const newItems = pastVehicleItems?.filter(
      (i: VehicleOfficeSearchViewModel) => i.slug !== item.slug
    );

    setPastVehicleItems(newItems);

    if (typeof window !== 'undefined')
      localStorage.setItem(CAR_RENTAL_PAST_SEARCH, JSON.stringify(newItems));
  };

  return {
    pastVehicleItems,
    saveVehicleSearch,
    clearPastVehicleSearch,
    removePastVehicleSearch,
  };
};
